import { createSlice } from "@reduxjs/toolkit";
import { createValuePreparer } from "./reduxUtils";

const initialState = {
  activeBoardList:[],
};

const activeBoard = createSlice({
  name: "activeBoard",
  initialState,
  reducers: {
    setActiveBoards: {
      prepare: createValuePreparer("activeBoardList"),
      reducer(state, action) {
        state.activeBoardList = action.payload.activeBoardList;
      },
    },
  },
});

export const { setActiveBoards } = activeBoard.actions;

export default activeBoard.reducer;
